export const Colors = {
  primary: '#94C21A',
  label: '#43425D',
  error: '#FF6565',
  green: '#94C21A',
  white: '#fff',
};
